import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import axios from "axios";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AIChat from "@/components/AIChat";

import Home from "@/pages/Home";
import Stenospace from "@/pages/Stenospace";
import Draftmaster from "@/pages/Draftmaster";
import CityPage from "@/pages/CityPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ToolsIndex from "@/pages/ToolsIndex";
import TypingTest from "@/pages/TypingTest";
import DraftingROI from "@/pages/DraftingROI";
import NotFound from "@/pages/NotFound";

import "@/App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function ScrollAndTrack() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    axios
      .post(`${API}/track/pageview`, {
        path: location.pathname,
        referrer: document.referrer,
      })
      .catch(() => {});
    // GA placeholder
    if (window.gtag) {
      window.gtag("event", "page_view", { page_path: location.pathname });
    }
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-[#FAFAFA] text-[#111111] min-h-screen font-body">
      <BrowserRouter>
        <ScrollAndTrack />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/stenopacemaster" element={<Stenospace />} />
            <Route
              path="/stenospacemaster"
              element={<Navigate to="/stenopacemaster" replace />}
            />
            <Route path="/draftmaster" element={<Draftmaster />} />
            <Route
              path="/steno/:citySlug"
              element={<CityPage product="steno" />}
            />
            <Route
              path="/legal-ai/:citySlug"
              element={<CityPage product="draftmaster" />}
            />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/tools" element={<ToolsIndex />} />
            <Route path="/tools/typing-speed-test" element={<TypingTest />} />
            <Route path="/tools/drafting-roi-calculator" element={<DraftingROI />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <AIChat />
        <Toaster position="bottom-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
